<template>
  <div
    v-if="annoucement?.data?.length"
    class="bg-primary text-white py-2.5 overflow-hidden group"
  >
    <div class="max-w-screen-xl mx-auto px-4 relative">
      <div class="flex items-center">
        <!-- Fixed Label with Play/Pause -->
        <div
          class="flex-shrink-0 flex items-center gap-2 pr-4 border-r border-white/20"
        >
          <button
            @click="togglePlay"
            class="hover:bg-white/10 p-1 rounded-full transition-colors"
          >
            <Icon
              v-if="isPlaying"
              name="heroicons:pause"
              class="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity"
            />
            <Icon v-else name="heroicons:play" class="w-4 h-4" />
          </button>
          <Icon name="heroicons:megaphone" class="w-4 h-4" />
          <span class="text-sm font-medium">Updates</span>
        </div>

        <!-- Scrolling Content -->
        <div class="flex-1 overflow-hidden px-4">
          <div class="ticker-wrap">
            <div class="ticker" :class="{ paused: !isPlaying }">
              <!-- Original Items -->
              <div
                v-for="(item, index) in annoucement.data"
                :key="`original-${index}`"
                class="ticker-item"
              >
                <nuxt-link
                  :to="item.attributes.url"
                  :target="item.attributes.isExternal ? '_blank' : '_self'"
                  class="text-sm font-medium hover:underline flex items-center gap-2"
                >
                  {{ item.attributes.text }}
                  <span class="relative flex h-2 w-2">
                    <span
                      class="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"
                    ></span>
                    <span
                      class="relative inline-flex rounded-full h-2 w-2 bg-white"
                    ></span>
                  </span>
                </nuxt-link>
              </div>
              <!-- Duplicate Items for Seamless Loop -->
              <div
                v-for="(item, index) in annoucement.data"
                :key="`duplicate-${index}`"
                class="ticker-item"
              >
                <nuxt-link
                  :to="item.attributes.url"
                  :target="item.attributes.isExternal ? '_blank' : '_self'"
                  class="text-sm font-medium hover:underline flex items-center gap-2"
                >
                  {{ item.attributes.text }}
                  <span class="relative flex h-2 w-2">
                    <span
                      class="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"
                    ></span>
                    <span
                      class="relative inline-flex rounded-full h-2 w-2 bg-white"
                    ></span>
                  </span>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const isPlaying = ref(true);
const { data: annoucement } = await useAsyncData("annoucement", () =>
  $fetch(
    "https://backend.postfeed.in/api/aa-announcements?&sort=createdAt:desc"
  )
);

const togglePlay = () => {
  isPlaying.value = !isPlaying.value;
};
</script>

<style scoped>
.ticker-wrap {
  width: 100%;
  overflow: hidden;
}

.ticker {
  display: inline-flex;
  white-space: nowrap;
  animation: ticker 70s linear infinite;
}

.ticker.paused {
  animation-play-state: paused;
}

.group:hover .ticker {
  animation-play-state: paused;
}

.ticker-item {
  flex-shrink: 0;
  padding: 0 2rem;
}

@keyframes ticker {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(
      -50%
    ); /* Only move half way since we duplicated the items */
  }
}
</style>
